export const CustomEvents = {
  LOADER_EVENTS: {
    show: 'loader:show',
    hide: 'loader:hide',
    showLocal: 'loader:showlocal',
    hideLocal: 'loader:hidelocal',
    visible: 'loader:visible',
    hidden: 'loader:hidden'
  },
  LOAD_COMPONENT: {
    simplebar: 'load:simplebar',
  },
  KEYBOARD_EVENTS: {
    escape: 'ku:key:escape',
    enter: 'ku:key:enter',
    tab: 'ku:key:tab',
  },
  MQ_EVENTS: {
    xs: {
      in: 'mq.xs.in',
      out: 'mq.xs.out',
      current: 'mq.xs.cur'
    },
    sm: {
      in: 'mq.sm.in',
      out: 'mq.sm.out',
      current: 'mq.sm.cur'
    },
    md: {
      in: 'mq.md.in',
      out: 'mq.md.out',
      current: 'mq.md.cur'
    },
    lg: {
      in: 'mq.lg.in',
      out: 'mq.lg.out',
      current: 'mq.lg.cur'
    },
    xl: {
      in: 'mq.xl.in',
      out: 'mq.xl.out',
      current: 'mq.xl.cur'
    }
  },
  // SEARCH_EVENTS: {
  //   visible: 'search:visible',
  //   hidden: 'search:hidden',
  //   toggle: 'search:toggle',
  //   trigger: 'click.search'
  // },
  BACKDROP_EVENTS: {
    show: 'backdrop:show',
    hide: 'backdrop:hide',
    hidden: 'backdrop:hidden',
    shown: 'backdrop:shown'
  },
  PRODUCT_EVENTS: {
    addtocart: 'product:addtocart',
    addedtocart: 'product:addedtocart',
    sizerequired: 'product:sizerequired',
    sizechanged: 'product:sizechanged',
    notifyme: 'product:notifyme',
    addtowish: 'product:addtowish',
    addedtowish: 'product:addetowish',
    removefromwish: 'product:removefromwish',
    removedfromwish: 'product:removedfromwish'
  },
  SIZES_EVENTS: {
    sizesopen: 'sizes:open',
    sizesclose: 'sizes:close'
  },
  FIDELITY_POPUP: {
    hide: 'fidPop:hide',
  },
  // CARTBAR_EVENTS: {
  //   cartbaropened: 'cartbar:open',
  //   cartbarclosed: 'cartbar:close'
  // },
  // DROPDOWN_EVENTS: {
  //   open: 'dropdown:open',
  //   close: 'dropdown:close',
  //   opened: 'dropdown:opened',
  //   closed: 'dropdown:closed',
  //   openCart: 'dropdown:opencart',
  // },
  MINICART_EVENTS: {
    open: 'minicart:open',
    updateqty: 'minicart:updateqty'
  },
  MODAL_EVENTS: {
    show: 'modal:show',
    hide: 'modal:hide',
    shown: 'modal:shown',
    hidden: 'modal:hidden',
    afterOpen: 'modal:afterOpen',
    afterClose: 'modal:afterClose',
    afterUpdateContent: 'modal:afterUpdateContent',
    egonValidation: 'modal:egonValidation',
  },
  SORT_BY_EVENTS: {
    changed: 'sortBy:changed'
  },
  FILTERS_EVENTS: {
    updated: 'query:updated',
    pageLoaded: 'ajaxPage:loaded'
  },
  PAGE_LAYOUT_EVENTS: {
    changed: 'pageLayout'
  },
  INFINITE_SCROLL_EVENTS: {
    next: 'infiniteScroll:next',
    animation: 'infiniteScroll:animation'
  },
  // FULL_MEDIA_EVENTS: {
  //   scrolled: 'fullMedia:scrolled'
  // },
  // HEADER_EVENTS: {
  //   expanded: 'header:expanded',
  //   collapsed: 'header:collapsed'
  // },
  // QUICK_CATEGORIES_EVENTS: {
  //   show: 'quickCategories:show',
  //   visible: 'quickCategories:visible'
  // },
  COOKIE: {
    accepted: 'cookie:accepted'
  },
  RETURN_EVENTS: {
    subsituteProduct: 'product:substituted'
  },
  CAROUSEL: {
    triggerCarousel: 'carousel:trigger'
  },
  // TOOLTIP_EVENTS: {
  //   create: 'tooltip:create',
  //   destroy: 'tooltip:destroy'
  // },
  MENU_EVENTS: {
    showMenu: 'menu:show',
    hideMenu: 'menu:hide'
  },
  SHIPMENT_EVENTS: {
    valid: 'checkout:proceed',
    invalid: 'checkout:stop'
  },
  PAYMENTS_EVENTS: {
    paypal: 'paypal:token'
  },
  CHANGE_AVAILABLE_LAYER:{
    available: 'availableChange:true'
  },
  CHANGE_RETURN_STEPS:{
    enableConfirm:'confirmBtn:enabled',
      disabledConfirm: 'confirmBtn:disabled',
  },
  SIZE_GUIDE:{
    openLayer:'sizeguide:open',
      closeLayer:'sizeguide:close',
  },
  NOTIFY_ME_STATE:{
    sent: 'notifyme:sent',
  },
  TRACKING:{
    loadMore: 'track:loadMore',
  },
  O2O:{
    ccManualSearch: "StoreLocator:Search:Place",
    ccStoreSelect: "StoreLocator:Store:Select",
  },
  VALIDATION:{
    bindValidation: "validation:bind",
  },
  FORM_EVENTS: {
    formSubmitted: 'form:submitted',
    formReplaced: 'form:replaced'
  }

};
